<template>
  <div class="admin-menu-page">
    <div class="admin-menu-container">
      <div class="page-header">
        <h1>Panel de Administración</h1>
        <p class="subtitle">Panel de control para administradores del sitio</p>
      </div>

      <div class="tabs-container">
        <div class="tabs-navigation">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-button', { active: activeTab === tab.id }]"
            @click="activeTab = tab.id"
          >
            <span class="tab-icon">{{ tab.icon }}</span>
            <span class="tab-label">{{ tab.label }}</span>
          </button>
        </div>

        <div class="tabs-content">
          <transition name="fade" mode="out-in">
            <component :is="currentTabComponent" :key="activeTab" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RocketSettingsTab from '@/components/adminmenu/RocketSettingsTab.vue';
import WidgetMasterTab from '@/components/adminmenu/WidgetMasterTab.vue';
import BannerSettingsTab from '@/components/adminmenu/BannerSettingsTab.vue';
import ForumActivoBannerSettingsTab from '@/components/adminmenu/ForumActivoBannerSettingsTab.vue';
import UserFeaturesTab from '@/components/adminmenu/UserFeaturesTab.vue';
import PlatinumEyesTab from '@/components/adminmenu/PlatinumEyesTab.vue';
import RoleSchedulerTab from '@/components/adminmenu/RoleSchedulerTab.vue';
import PreEurekersTab from '@/components/adminmenu/PreEurekersTab.vue';
import VuelvePromoTab from '@/components/adminmenu/VuelvePromoTab.vue';
import ReferralsSettingsTab from '@/components/adminmenu/ReferralsSettingsTab.vue';
import ZopimSettingsTab from '@/components/adminmenu/ZopimSettingsTab.vue';
import NewsflashSettingsTab from '@/components/adminmenu/NewsflashSettingsTab.vue';

export default {
  name: 'AdminMenu',
  components: {
    RocketSettingsTab,
    WidgetMasterTab,
    BannerSettingsTab,
    ForumActivoBannerSettingsTab,
    UserFeaturesTab,
    RoleSchedulerTab,
    PreEurekersTab,
    VuelvePromoTab,
    PlatinumEyesTab,
    ReferralsSettingsTab,
    ZopimSettingsTab,
    NewsflashSettingsTab
  },
  data() {
    return {
      activeTab: 'rocket',
      tabs: [
        {
          id: 'rocket',
          label: 'Configuración Rocket',
          icon: '🚀',
          component: 'RocketSettingsTab'
        },
        {
          id: 'widget',
          label: 'Widget Master',
          icon: '📦',
          component: 'WidgetMasterTab'
        },
        {
          id: 'banner',
          label: 'Banner Settings',
          icon: '🏷️',
          component: 'BannerSettingsTab'
        },
        {
          id: 'forum-activo-banner',
          label: 'Publicidad Foro',
          icon: 'AD',
          component: 'ForumActivoBannerSettingsTab'
        },
        {
          id: 'users',
          label: 'Gestión de Usuarios',
          icon: '👤',
          component: 'UserFeaturesTab'
        },
        {
          id: 'platinum-eyes',
          label: 'Platinum Eyes',
          icon: '👁️',
          component: 'PlatinumEyesTab'
        },
        {
          id: 'scheduler',
          label: 'Programador de Roles',
          icon: '⏰',
          component: 'RoleSchedulerTab'
        },
        {
          id: 'pre-eurekers',
          label: 'Pre-Eurekers',
          icon: '🎯',
          component: 'PreEurekersTab'
        },
        {
          id: 'vuelve-promo',
          label: 'Vuelve Promo',
          icon: 'VP',
          component: 'VuelvePromoTab'
        },
        {
          id: 'referrals',
          label: 'Referidos',
          icon: '🎁',
          component: 'ReferralsSettingsTab'
        },
        {
          id: 'zopim',
          label: 'Chat Zopim',
          icon: '💬',
          component: 'ZopimSettingsTab'
        },
        {
          id: 'newsflash',
          label: 'Noticias flash',
          icon: 'NF',
          component: 'NewsflashSettingsTab'
        }
      ]
    };
  },
  computed: {
    currentTabComponent() {
      const tab = this.tabs.find(t => t.id === this.activeTab);
      return tab ? tab.component : 'RocketSettingsTab';
    }
  }
};
</script>

<style scoped>
.admin-menu-page {
  min-height: 100vh;
  background-color: #121212;
  color: #e6e6e6;
  padding: 20px;
}

.admin-menu-container {
  max-width: 1400px;
  margin: 0 auto;
  background: #222;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border: 1px solid #333;
  overflow: hidden;
}

.page-header {
  padding: 30px;
  border-bottom: 1px solid #333;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
}

.page-header h1 {
  color: #ffffff;
  font-size: 32px;
  font-weight: 300;
  margin: 0 0 10px 0;
}

.subtitle {
  color: #b8d4f1;
  font-size: 16px;
  margin: 0;
}

.tabs-container {
  display: flex;
  min-height: 600px;
}

.tabs-navigation {
  width: 280px;
  background: #1a1a1a;
  border-right: 1px solid #333;
  padding: 20px 0;
  flex-shrink: 0;
}

.tab-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 25px;
  background: transparent;
  border: none;
  color: #bbb;
  cursor: pointer;
  font-size: 15px;
  text-align: left;
  transition: all 0.2s ease;
  position: relative;
}

.tab-button:hover {
  background: #252525;
  color: #3498db;
}

.tab-button.active {
  background: #2c2c2c;
  color: #3498db;
  font-weight: 500;
}

.tab-button.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #3498db;
}

.tab-icon {
  font-size: 20px;
  margin-right: 12px;
  display: inline-block;
  width: 24px;
}

.tab-label {
  flex: 1;
}

.tabs-content {
  flex: 1;
  background: #222;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

/* Fade transition for tab switching */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Responsive design */
@media (max-width: 1024px) {
  .admin-menu-container {
    margin: 0;
    border-radius: 0;
  }

  .tabs-container {
    flex-direction: column;
  }

  .tabs-navigation {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #333;
    display: flex;
    overflow-x: auto;
    padding: 0;
  }

  .tab-button {
    flex-direction: column;
    padding: 15px 20px;
    min-width: 120px;
    text-align: center;
  }

  .tab-button.active::before {
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    width: auto;
    height: 3px;
  }

  .tab-icon {
    margin-right: 0;
    margin-bottom: 5px;
  }

  .tabs-content {
    max-height: none;
  }
}

@media (max-width: 768px) {
  .admin-menu-page {
    padding: 0;
  }

  .page-header {
    padding: 20px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
  }

  .tab-button {
    font-size: 13px;
    min-width: 100px;
    padding: 12px 15px;
  }

  .tab-icon {
    font-size: 18px;
  }
}

/* Custom scrollbar for tabs content */
.tabs-content::-webkit-scrollbar {
  width: 8px;
}

.tabs-content::-webkit-scrollbar-track {
  background: #1a1a1a;
}

.tabs-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}

.tabs-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
